import PropTypes from 'prop-types';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import H2 from 'UIComponents/elements/headings/H2';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ForgotPasswordModal = ({
  emailAddressFromProfile,
  onResetPassword,
  onCloseModal
}) => /*#__PURE__*/_jsxs(UIModal, {
  children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onCloseModal
    }), /*#__PURE__*/_jsx(H2, {
      children: I18n.text('userPreferences.labels.forgotPassword')
    })]
  }), /*#__PURE__*/_jsx(UIDialogBody, {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "userPreferences.descriptions.resetPassword",
      options: {
        emailAddress: emailAddressFromProfile
      }
    })
  }), /*#__PURE__*/_jsxs(UIDialogFooter, {
    children: [/*#__PURE__*/_jsx(UIButton, {
      use: "primary",
      onClick: onResetPassword,
      children: I18n.text('userPreferences.labels.resetPassword')
    }), /*#__PURE__*/_jsx(UIButton, {
      use: "secondary",
      onClick: onCloseModal,
      children: I18n.text('userPreferences.labels.cancel')
    })]
  })]
});
ForgotPasswordModal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  onResetPassword: PropTypes.func.isRequired,
  emailAddressFromProfile: PropTypes.string.isRequired
};
export default ForgotPasswordModal;